import { PalmButton } from '@native/cloudpilot_web';

/**
 * The various supported hard buttons.
 */
export enum Button {
    cal = PalmButton.cal,
    phone = PalmButton.phone,
    todo = PalmButton.todo,
    notes = PalmButton.notes,
    up = PalmButton.up,
    down = PalmButton.down,
    power = PalmButton.power,
    cradle = PalmButton.cradle,
}
